<template>
    <div class="auth-wrapper">
  <div class="auth-container">
    <h2>Redefinir senha</h2>
    <form @submit.prevent="resetPassword">
      <div class="mb-3">
        <label for="password" class="form-label">Nova senha</label>
        <input
          v-model="password"
          type="password"
          id="password"
          class="form-control"
          required
          placeholder="Digite sua nova senha"
        />
      </div>

      <div class="mb-3">
        <label for="confirmPassword" class="form-label">Confirme a nova senha</label>
        <input
          v-model="confirmPassword"
          type="password"
          id="confirmPassword"
          class="form-control"
          required
          placeholder="Confirme a nova senha"
        />
      </div>

      <button type="submit" :disabled="loading" class="btn-submit">
        <span v-if="loading">
          <i class="fas fa-spinner fa-spin"></i> Salvando...
        </span>
        <span v-else>Redefinir senha</span>
      </button>

      <div class="links">
        <router-link to="/login">Voltar para o login</router-link>
      </div>
    </form>
  </div>
  </div>
</template>

<script>
import { useAlertStore } from '@/stores/alertStore';
import api from '@/services/api';

export default {
  name: 'ResetPassword',
  data() {
    return {
      password: '',
      confirmPassword: '',
      loading: false,
    };
  },
  methods: {
    async resetPassword() {
      const alert = useAlertStore();

      if (this.password !== this.confirmPassword) {
        alert.show('As senhas não coincidem.');
        return;
      }

      this.loading = true;
      try {
        alert.loading(true);
        await api.post('/auth/reset-password', { password: this.password });
        alert.show('Senha redefinida com sucesso!');
        this.$router.push('/login');
      } catch (error) {
        alert.show('Erro ao redefinir a senha. Tente novamente.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.auth-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}

.auth-container {
  width: 100%;
  max-width: 400px;
  padding: 30px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  color: #32355d;
}
h2 {
  margin-bottom: 20px;
  color: #f78da7;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 600;
  color: #32355d;
  margin-bottom: 0.4rem;
  display: block;
  font-size: 0.9rem;
}

/* ── Input padrão ────────────────────────────────────────── */
.form-control {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 0.625rem;
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
  color: #32355d;
  width: 100%;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.form-control::placeholder {
  color: #b0b0b0;
  font-size: 0.9rem;
}

.form-control:focus {
  background-color: #ffffff;
  border-color: #ff50a3;
  box-shadow: 0 0 0 0.2rem rgba(255, 80, 163, 0.18);
  outline: none;
  color: #32355d;
}

.btn-submit {
  background-color: #ff50a3;
  color: #fff;
  border: 1px solid #ff50a3;
  padding: 0.85rem 1.5rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 0.625rem;
  cursor: pointer;
  width: 100%;
  margin-top: 0.5rem;
  transition: all 0.2s ease-in-out;
}

.btn-submit:hover:not(:disabled) {
  background-color: #e64593;
  border-color: #e64593;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.links {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  text-align: center;
}

.links a {
  color: #32355d;
  text-decoration: none;
}

.links a:hover {
  text-decoration: underline;
}
</style>
